import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <nav className="mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-lg flex items-center justify-center">
              <i className="ri-brain-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              MetaMind
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <a href="#features" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
              Features
            </a>
            <a href="#ai-capabilities" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
              AI Technology
            </a>
            <a href="#how-it-works" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
              How It Works
            </a>
            <a href="#products" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
              Marketplace
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
              Testimonials
            </a>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <button className="px-5 py-2.5 text-gray-700 hover:text-indigo-600 font-medium transition-colors cursor-pointer whitespace-nowrap">
              Sign In
            </button>
            <button className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:shadow-lg hover:shadow-indigo-500/50 transition-all font-medium cursor-pointer whitespace-nowrap">
              Get Started
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
                Features
              </a>
              <a href="#ai-capabilities" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
                AI Technology
              </a>
              <a href="#how-it-works" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
                How It Works
              </a>
              <a href="#products" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
                Marketplace
              </a>
              <a href="#testimonials" className="text-gray-700 hover:text-indigo-600 transition-colors font-medium cursor-pointer">
                Testimonials
              </a>
              <div className="flex flex-col space-y-3 pt-4">
                <button className="px-5 py-2.5 text-gray-700 hover:text-indigo-600 font-medium transition-colors cursor-pointer whitespace-nowrap text-left">
                  Sign In
                </button>
                <button className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:shadow-lg hover:shadow-indigo-500/50 transition-all font-medium cursor-pointer whitespace-nowrap">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
